import {
  VENDOR_MOBILE_NO,
  VENDOR_MOBILE_NO_SUCCESSFUL,
  GENERATE_OTP,
  GENERATE_OTP_SUCCESSFUL,
  CHECK_OTP,
  CHECK_OTP_SUCCESSFUL,
  Q_DOC_REPORT,
  Q_DOC_REPORT_SUCCESS,
  Q_DOC_PDF,
  API_ERROR,
} from "./actionTypes";

const initialState = {
  loginError: {},
  VendorMobile: {},
  VendorData: {},
  loadVendorpage: false,
  otp: null,
  message: null,
  loading: false,

  Q_Doc_report: {},
  QuotationPdf: false,
};

const VendorQuotation = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_MOBILE_NO:
      state = {
        ...state,
        VendorMobile: {},
        otp: null,
        loading: true,
      };
      break;
    case VENDOR_MOBILE_NO_SUCCESSFUL:
      state = {
        ...state,
        VendorMobile: action.payload,
        loading: false,
      };
      break;
    case GENERATE_OTP:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GENERATE_OTP_SUCCESSFUL:
      state = {
        ...state,
        otp: action.payload,
        loading: false,
      };
      break;
    case CHECK_OTP:
      state = {
        ...state,
        loading: true,
        loginError: {},
      };
      break;
    case CHECK_OTP_SUCCESSFUL:
      state = {
        ...state,
        loadVendorpage: true,
        VendorData: action.payload,
        loading: false,
      };
      break;
    // Vendor Quotation Report
    case Q_DOC_REPORT:
      state = {
        ...state,
        loading: false,
      };
      break;
    case Q_DOC_REPORT_SUCCESS:
      state = {
        ...state,
        Q_Doc_report: action.payload,
        loading: false,
      };
      break;
    case Q_DOC_PDF:
      state = {
        ...state,
        QuotationPdf: action.payload.QuotationPdf,
        loading: false,
      };
      break;

    case API_ERROR:
      state = {
        ...state,
        loading: false,
        loginError: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VendorQuotation;
